module.exports = __webpack_public_path__ + "static/media/5-1.2e436bf9.jpg";